import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import Section from "./section"
import CCardCta from "../elements/c_card_cta"

const MCardrowCTA = ({ data }) => {
  return (
    <Section
      baseClass="m-CardRow m-CardRow--cta"
      defaultPadding="extra-large"
      data={data}
    >
      <div className="m-CardRow-wrapper">
        <div className="m-CardRow-container m-CardRow-container--headline">
          <DfbHeadline
            headline={data.headline}
            headline_level="h3"
            add_class="m-CardRow-headline"
          />
          {data.memberCount?.number && data.memberCount?.label && (
            <div className="c-CardRow-membercount">
              <span className="m-CardRow-membercount-label">
                {data.memberCount.label} {data.memberCount.number}
              </span>
            </div>
          )}
        </div>
        <div className="c-CardRow m-CardRow-container">
          <div className="c-CardRow-container">
            {data.card_cta_item.map((item, index) => {
              // Add use_c_card_cta_item_structure to item to handle different structure from cms
              item.use_c_card_cta_item_structure = true
                return (
                <div key={item.uid} className="c-CardRow-card">
                  <CCardCta data={item} key={index} />
                </div>
              )}
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardrowCTA
